import memoize from 'lodash/memoize';
import { BUNDLED_DISEASE_OPTIONS, GENERAL_DISEASE_SUB_TYPE, GENERAL_DISEASE } from 'utils/constants/disease';
import NumberTypes from 'utils/constants/numberTypes';
import { questionnaireApi } from './api';

// returns all diseases, including OTHER_DISEASE
// GENERAL_DISEASE is replaced by its subtypes
export const getDiseaseOptions = memoize(
  async () => {
    const serverDiseases = await questionnaireApi.getDiseasesList();
    return [
      ...BUNDLED_DISEASE_OPTIONS.map((i) => ({ ...i, isTranslationNeeded: true })),
      ...serverDiseases.map(({ label, name }) => ({ label, value: name, isTranslationNeeded: false })),
      {
        label: 'questionnaire.questions.general.type_of_ca.option.pancreas',
        value: GENERAL_DISEASE_SUB_TYPE.PANCREATIC,
        isTranslationNeeded: true,
      },
      {
        label: 'questionnaire.questions.general.type_of_ca.option.testicular_cancer',
        value: GENERAL_DISEASE_SUB_TYPE.TESTICULAR,
        isTranslationNeeded: true,
      },
    ].filter(({ value }) => value !== GENERAL_DISEASE);
  },
  null,
);

export const getNumberInputParameters = (type) => {
  switch (type) {
    case NumberTypes.int:
      return {
        min: 0,
        step: 1,
        unit: 'number_input.number_type.mm',
      };
    case NumberTypes.intWithoutUnit:
      return {
        min: 0,
        step: 1,
        unit: '',
      };
    case NumberTypes.fraction:
      return {
        min: 0,
        step: 0.1,
        unit: 'number_input.number_type.cm',
      };
    case NumberTypes.fractionWithoutUnit:
      return {
        min: 0,
        step: 0.1,
        unit: '',
      };
    case NumberTypes.uML:
      return {
        min: 0,
        step: 0.1,
        unit: 'U/ml',
      };
    case NumberTypes.gDL:
      return {
        min: 0,
        step: 1,
        unit: 'g/dL',
      };
    case NumberTypes.cellUl:
      return {
        min: 0,
        step: 1,
        unit: 'cells/uL',
      };
    case NumberTypes.uLCube:
      return {
        min: 0,
        step: 1,
        unit: '10³/uL',
      };
    case NumberTypes.percentage:
      return {
        min: 0,
        max: 100,
        step: 1,
        unit: '%',
      };
    default:
      // default should be fraction
      return {
        min: 0,
        step: 0.1,
        unit: 'number_input.number_type.cm',
      };
  }
};
